import { api } from '../index';

const prefix = '/api/basic_info/salesteam/';

export function apiIndex() {
	return api.get(prefix + 'index');
}

export function apiSelectSalesTeamBackupUserList(param) {
	return api.post(prefix + 'selectSalesTeamBackupUserList', param);
}

// export function apiSelectUserList(param) {
// 	return api.post(prefix + 'selectUserList', param);
// }

// export function apiSelectUser(param) {
// 	return api.post(prefix + 'selectUser', param);
// }

// export function apiChangePassword(param) {
// 	return api.post(prefix + 'changePassword', param);
// }

export function apiInsertSalesTeamBackupUsers(param) {
	param.mode = 'insert';
	return apiSubmitSalesTeamBackupUsers(param);
}

export function apiDeleteSalesTeamBackupUsers(param) {
	param.mode = 'delete';
	return apiSubmitSalesTeamBackupUsers(param);
}

function apiSubmitSalesTeamBackupUsers(param) {
	return api.post(prefix + 'submitSalesTeamBackupUsers', param);
}

// export function apiEncryptPasswords() {
// 	return api.get(prefix + 'encryptPasswords');
// }
